import id from './id'

const name = {
  field: 'name',
  type: 'string',
  datatype: 'varchar',
  default_value: 'Demo Site',
  length: 100
}

const tel = {
  field: 'tel',
  type: 'string',
  datatype: 'varchar',
  length: 100
}

const email = {
  field: 'email',
  type: 'string',
  datatype: 'varchar',
  length: 100
}


export default {
  collection: 'site_config',
  note: 'サイトの設定です。',
  single: true,
  fields: [
    id,
    name,
    tel,
    email
  ]
}
